<div class="u-shadow-mini {{ sectionclass }}" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap primary-color-bg"
		>
			<div class="o-stack__cell">
				<h5>
					{{ sectiontitle }}
					<div class="o-stack o-stack--nowrap o-stack--center legend-list" *ngIf="isR103 && hasData">
						<div class="social-demographic-gender-list-cntr">
							<ul class="gender-div">
								<li
									*ngFor="let legendItem of legend; let index = index"
									class="social-demographic-gender-list-item"
									[ngClass]="
										currentLegendItem == legendItem.value
											? 'activeGender tertiary-color-bg'
											: ' tertiary-color-bg-opacity'
									"
									(click)="updateLegend(legendItem.value)"
								>
									{{ legendItem.displayName }}
								</li>
							</ul>
						</div>
					</div>
					<span *ngIf="hasData">
						<a
							href="javascript:void(0)"
							class="datatable_download_icon"
							(click)="downloadCSV()"
							target="_blank"
							*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
						>
							<img *ngIf="downloadIcon" class="download-icon-svg" src="{{ downloadIcon }}" />
							<i
								class="fa fa-download"
								aria-hidden="true"
								*ngIf="!downloadConfiguration.downloadPNGIcon && !downloadIcon"
							></i>
							<img
								*ngIf="downloadConfiguration.downloadPNGIcon && !downloadIcon"
								class="download-icon-svg"
								src="../../../../../assets/images/Download_Icon_R7.svg"
							/>
						</a>
					</span>
				</h5>
			</div>
		</div>
		<div class="analytics-portlet-content">
			<div class="o-stack o-stack--nowrap o-stack--center legend-list" *ngIf="!isR103 && hasData">
				<div class="social-demographic-gender-list-cntr">
					<ul class="gender-div">
						<li
							*ngFor="let legendItem of legend; let index = index"
							class="social-demographic-gender-list-item"
							[ngClass]="
								currentLegendItem == legendItem.value ? 'activeGender tertiary-color-bg' : ' tertiary-color-bg-opacity'
							"
							(click)="updateLegend(legendItem.value)"
						>
							{{ legendItem.displayName }}
						</li>
					</ul>
				</div>
			</div>
			<div class="chart-div" *ngIf="hasData">
				<div #chartElement id="chart-element"></div>
			</div>
			<div class="map-no-data" *ngIf="!hasData">No Data to Display</div>
		</div>
	</div>
</div>
